import React from "react";
import { StyleLeft, StyleRight, StyleSubscriptionCard } from "./style";
import Typography from "@components/typography";

const SubscriptionCard = ({ item }) => {
  return (
    <StyleSubscriptionCard status={item.status}>
      <StyleLeft>
        <Typography size={28} weight={600}>
          {item.count}
        </Typography>
        <Typography size={16} weight={600}>
          {item.title}
        </Typography>
      </StyleLeft>
      <StyleRight>
        <img src={item.icon} alt="" width={40} />
      </StyleRight>
    </StyleSubscriptionCard>
  );
};

export default SubscriptionCard;
